<i18n>
{
    "ja": {

        "sections": {
            "1": {
                "title": "株式会社iWA",
                "subtitle": "イノベーションを極め、革新の心で社会に驚異と感動をもたらし、持続可能な明日へと道を切り開く。"
            },
            "about": {
                "title": "会社概要",
                "row1": {
                    "title": "我々について",
                    "content": "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;iWAは、革新を追い求める探究者であり、現状に満足することなく常に新しい技術とアイデアを社会に提供しています。我々の行動は、驚きと感動を生み出し、人々の生活を豊かにすることを目的としています。そして、持続可能な未来を実現するために、イノベーションを心の核として、より良い世界への道を切り拓いています。"
                },
                "row2": {
                    "title": "カスタムソフトウェアの開発",
                    "content": "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;最先端のプログラミングとデザイン技術を駆使して、革新的なウェブサイト、システム、AndroidとiOSアプリケーション、AIソリューション、そしてゲームの開発を手掛けています。私たちは、オーダーメイドのアイデアとイノベーションを具現化し、現代のニーズに応える高速でパワフルなプラットフォームを創出します。詳細な分析、厳密な企画、および革新的な開発プロセスを経て、未来を見据えたソリューションを提供します！"
                }
            },
            "contact": {
                "subtitle": "メッセージを残してください。"
            },
            "timeline": {
                "title": "沿革年表",
                "subtitle": "iWAの歴史の中で最も重要な日付とイベント"
            },
            "products": {
                "title": "商品＆事業",
                "subtitle": "iWAが提供するサービスとソリューション"
            },
            "industries": {
                "title": "開発産業",
                "subtitle": "人々の生活に便利さと楽しさをもたらすソフトウェアの開発に取り組んでいます。",
                "cols": [
                    {
                        "headline": "オーダーメイド",
                        "description": "先端技術とカスタマイズドソリューションを駆使し、ビジネスの未来像を現実化させ、無限の可能性を拓き、成長を加速化します。"
                    },
                    {
                        "headline": "イノベーティブ",
                        "description": "独自のサービス開発を通じて未踏の市場を切り開き、ビジネスに新たな価値を注入し、革新による成長の波をリードします。"
                    },
                    {
                        "headline": "エンターテイメント",
                        "description": "最新技術と創造性の融合で、日常に新たな喜びと感動をもたらし、忘れられない瞬間を生み出し、人々の心に響く体験の未来を創造しています。"
                    }
                ]
            },
            "actions": {
                "contact": "お問い合わせ",
                "about": "会社概要",
                "products": "製品紹介"
            }
        },
        "timeline": [
            {
                "title": "株式会社iWAを設立",
                "content": "iWAは、最新技術と革新的なアイデアを社会に提供し、人々の生活を豊かにし、持続可能な未来を実現することを目指して設立されました。"
            },
            {
                "date": "Coming Soon",
                "title": "リンクスマイル(仮)の立ち上げ",
                "content": "iWAが開発したマッチングアプリ「リンクスマイル(仮)」は、新しい出会いと深い繋がりの機会を提供し、コミュニケーションの障壁を打破する革新的なプラットフォームとして日本市場に導入予定。"
            }
        ],
        "contact": {
            "subheader": "または、下記までご連絡ください",
            "facebook": "FaceBook",
            "x": "X(旧twitter)"
        },
        "projects": {
            "contact": {
                "title": "リンクスマイル(仮)",
                "subtitle": "リンクスマイル(仮)・プロジェクトは、適切な時期に詳細を発表する予定である。"
            }
        }
    },
    "en": {
        "sections": {
            "1": {
                "title": "iWA Inc.",
                "subtitle": "We strive for the pinnacle of innovation, bringing wonder and emotion to society with a spirit of revolution, paving the way for a sustainable tomorrow."
            },
            "about": {
                "title": "Company Profile",
                "row1": {
                    "title": "Company Profile",
                    "content": "iWA is a seeker of innovation, never content with the status quo, always providing society with new technologies and ideas. Our actions are aimed at creating surprise and emotion, enriching people's lives. With innovation at the core of our hearts, we are paving the way to a better world in pursuit of a sustainable future."
                },
                "row2": {
                    "title": "Custom Software Development",
                    "content": "Utilizing cutting-edge programming and design technologies, we specialize in developing innovative websites, systems, Android and iOS applications, AI solutions, and games. We are dedicated to materializing bespoke ideas and innovations, creating fast and powerful platforms that meet modern needs. Through detailed analysis, meticulous planning, and innovative development processes, we deliver forward-looking solutions."
                }
            },
            "contact": {
                "subtitle": "Leave a Message"
            },
            "timeline": {
                "title": "Timeline of our history",
                "subtitle": "the most important dates and events in iWA's history"
            },
            "products": {
                "title": "Our Products & Projects",
                "subtitle": "Services and Solutions Provided by iWA"
            },
            "industries": {
                "title": "Development Industry",
                "subtitle": "We are committed to developing software that brings convenience and enjoyment to people's lives.",
                "cols": [
                    {
                        "headline": "Custom-Made",
                        "description": "By leveraging cutting-edge technology and customized solutions, we materialize the future vision of businesses, unlock infinite possibilities, and accelerate growth."
                    },
                    {
                        "headline": "Innovative",
                        "description": "Through the development of unique services, we pioneer untapped markets, inject new value into businesses, and lead the wave of growth through innovation."
                    },
                    {
                        "headline": "Entertainment",
                        "description": "By merging the latest technology with creativity, we bring new joy and emotion to everyday life, create unforgettable moments, and craft the future of experiences that resonate with people's hearts."
                    }
                ]
            },
            "actions": {
                "contact": "Contact Us",
                "about": "Company Profile",
                "products": "Our Products"
            }
        },
        "timeline": [
            {
                "title": "Founding iWA inc.",
                "content": "iWA was founded with the aim of providing society with the latest technology and innovative ideas to enrich people's lives and realize a sustainable future."
            },
            {
                "date": "Soon",
                "title": "Launch of Link Smile (tentative)",
                "content": "he matching app 'LinkSmile (tentative)' developed by iWA is set to be introduced to the Japanese market as an innovative platform that offers opportunities for new encounters and deeper connections, breaking down barriers to communication."
            }
        ],
        "contact": {
            "subheader": "or contact us via:",
            "facebook": "FaceBook",
            "x": "X(former twitter)"
        },
        "projects": {
            "contact": {
                "title": "LinkSmile (tentative)",
                "subtitle": "The LinkSmile (tentative) project is planned to announce details at the appropriate time."
            }
        }
    }
}
</i18n>
<template>
    <div class="page page-sections">
        <section id="headerSection" data-section="home" class="header-section dark-gradient fullpage-section">
            <animated-background />
            <v-container v-if="!loading" class="fill-height pt-12" :class="{'align-center': phoneOnly}">
                <v-slide-y-transition appear >
                <h1 class="strong-text--text">
                    <animate-text :duration="1500" :stop-after="0" :delay="500" :text="$t('sections.1.title')" />
                    <!-- <span class="secondary--text font-weight-medium">iWA</span> -->
                </h1>
                </v-slide-y-transition>
                <v-slide-x-transition appear>
                <h2 class="text--text mt-5">
                    <animate-text @done="showSection1Actions = true" :duration="2500" :delay="2000" :text="$t('sections.1.subtitle')"></animate-text>
                    <!-- <div>Information Technology & Electronic Business Company</div> -->
                </h2>
                </v-slide-x-transition>
                <div class="actions" :class="{'fade-up-off': !showSection1Actions, 'fade-up-on': showSection1Actions}">
                    <!-- <v-btn @click="navigateToLink('#productsSection')" color="strong-text" tile :large="pcOnly" depressed outlined class="me-6">{{$t('sections.actions.products')}}</v-btn> -->
                    <v-btn @click="navigateToLink('#aboutSection')" color="strong-text" tile :large="pcOnly" depressed outlined class="me-6">{{$t('sections.actions.about')}}</v-btn>
                    <v-btn @click="navigateToLink('#contactSection')" color="secondary" tile :large="pcOnly" outlined>{{$t('sections.actions.contact')}}</v-btn>
                </div>
            </v-container>

            <div class="section-scroll-icon">
                <scroll-icon @click="scrollToSection(2)"/>
            </div>
        </section>
        <e-section id="aboutSection" data-section="about" :headline="$t('sections.about.title')" light divider>
            <v-row>
                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'" data-aos-duration="800" :cols="pcOnly ? 6 : 12" class="">
                    <v-img src="/img/vector1.png" contain width="100%" max-height="480"></v-img>
                </v-col>
                <v-spacer></v-spacer>
                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'" data-aos-duration="800" class="mt-6 mt-lg-0" :cols="pcOnly ? 6 : 12">
                    <h1 class="headline">{{$t('sections.about.row1.title')}}</h1>
                    <p class="medium-text text-light--text mt-6 mt-lg-8" :class="{'text-center': phoneOnly}" v-html="$t('sections.about.row2.content')">
                    </p>
                    <div class="actions">
                        <v-btn @click="navigateToLink('#industriesSection')" tile large depressed color="primary">{{$t('sections.industries.title')}}</v-btn>
                        <v-btn @click="navigateToLink('#timelineSection')" tile large depressed color="primary" outlined class="ms-lg-4">{{$t('sections.timeline.title')}}</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row style="margin-top: 3.5rem" class=" flex-row-reverse">

                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-right' : 'fade-left') : 'fade-up'" data-aos-duration="800" :cols="pcOnly ? 6 : 12" class="">
                    <v-img src="/img/vector2.png" contain width="100%" max-height="480"></v-img>
                </v-col>
                <v-spacer></v-spacer>
                <v-col :data-aos="pcOnly ? (isRtl ? 'fade-left' : 'fade-right') : 'fade-up'" data-aos-duration="800" class="mt-6 mt-lg-0" :cols="pcOnly ? 6 : 12">
                    <h1 class="headline">{{$t('sections.about.row2.title')}}</h1>
                    <p class="medium-text text-light--text mt-6 mt-lg-8" :class="{'text-center': phoneOnly}" v-html="$t('sections.about.row2.content')">
                    </p>

                    <div class="actions">
                        <v-btn @click="navigateToLink('#productsSection')" tile large depressed color="primary">{{$t('sections.products.title')}}</v-btn>
                        <!-- <v-btn @click="navigateToLink('#timelineSection')" tile large depressed color="primary" outlined class="ms-4">{{$t('sections.timeline.title')}}</v-btn> -->
                    </div>
                </v-col>
            </v-row>
        </e-section>

        <cols-section id="industriesSection" :headline="$t('sections.industries.title')" :subtitle="$t('sections.industries.subtitle')" :cols="industriesCols">
        </cols-section>

        <e-section id="productsSection" data-section="products" background="light" :headline="$t('sections.products.title')" :subtitle="$t('sections.products.subtitle')" light>
            <v-row class="flex-wrap justify-center">
                <v-col v-for="(project, i) in projects" :key="i" :cols="pcOnly ? 5 : 12">
                    <v-card v-ripple="project.href ? {class: 'soft-ripple'} : false" data-aos="fade-up" :data-aos-duration="800" :data-aos-delay="400*i" class="card-shadow fill-height" :href="project.href ? project.href : ''" :target="project.href ? '_blank' : ''">
                        <v-img :src="project.image" cover height="400" />
                        <div class="py-1 px-3">
                            <v-card-title class="justify-center primary--text mb-1">{{$t('projects.contact.' + project.title)}}</v-card-title>
                            <v-card-subtitle>{{$t('projects.contact.' + project.subtitle)}}</v-card-subtitle>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </e-section>

        <e-section id="timelineSection" data-section="timeline" divider :headline="$t('sections.timeline.title')" :subtitle="$t('sections.timeline.subtitle')" light>
            <timeline data-aos="fade-up" :data-aos-duration="800" :data="timeline" />
        </e-section>

        <e-section id="contactSection" data-section="contact" :headline="$t('links.contact')" :subtitle="$t('sections.contact.subtitle')" light>
            <v-row class="justify-center px-lg-12">
                <v-col :cols="pcOnly ? 6 : 12" class="ps-lg-12">
                    <contact-form data-once :data-aos="'fade'" :data-aos-duration="800" />
                </v-col>
                <v-col v-if="pcOnly" cols="1" class="text-center">
                    <v-divider vertical></v-divider>
                </v-col>
                <v-col :cols="pcOnly ? 4 : 12">
                    <div :data-aos="'fade'" :data-aos-duration="800">
                        <v-subheader>
                            {{$t('contact.subheader')}}
                        </v-subheader>
                        <v-list two-line>
                            <v-list-item v-for="item in contactItems" :key="item.name" :target="item.href ? '_blank' : ''" :href="item.href ? item.href : (item.name === 'email' ? `mailto:${item.value}` : '')">
                                <v-list-item-icon>
                                    <v-icon :color="item.color">{{item.icon}}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle class="mb-2">{{$t('contact.' + item.name)}}</v-list-item-subtitle>
                                    <v-list-item-title>{{item.value}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>

                    </div>
                </v-col>
            </v-row>
        </e-section>
        <e-footer />

        <scroll-to-top />
    </div>
</template>

<script>
// @ is an alias to /src
import 'particles.js';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles


import ScrollToTop from '@/components/custom/scroll-to-top'
import AnimateText from '@/components/custom/animate-text'
import ScrollIcon from '@/components/custom/scroll-icon'
import ContactForm from '@/components/custom/contact-form'
import AnimatedBackground from '@/components/custom/animated-background'
import ColsSection from '@/components/default/cols-section'
import ESection from '@/components/default/e-section'
import Timeline from '@/components/default/timeline'
import EFooter from '@/components/main/e-footer'


import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Home",
    components: {
        ScrollToTop,
        ContactForm,
        AnimateText,
        Timeline,
        ColsSection,
        ESection,
        ScrollIcon,
        EFooter,
        AnimatedBackground
    },
    data(){
        return {
            showSection1Actions: false,
            currentScrollTop: 0,

            contactItems: [
                {
                    name: 'facebook',
                    icon: 'mdi-facebook',
                    value: 'Under Preparation',
                    color: 'blue darken-1',
                    href: ''
                },
                {
                    name: 'x',
                    icon: 'mdi-file-excel-box-outline',
                    value: 'Under Preparation',
                    color: 'black',
                    href: ''
                }
            ],
            projects: [
                {
                    image: '/img/linksmail.webp',
                    title: "title",
                    subtitle: "subtitle"
                },
            ],
        }
    },
    computed: {
        industriesCols(){
            return [
               {
                   color: 'blue',
                   icon: 'mdi-handshake-outline',
                   headline: this.$t('sections.industries.cols.0.headline'),
                   description: this.$t('sections.industries.cols.0.description')
               },
               {
                   color: 'deep-orange',
                   icon: 'mdi-lightbulb-on-outline',
                   headline: this.$t('sections.industries.cols.1.headline'),
                   description: this.$t('sections.industries.cols.1.description')
               },
               {
                   color: 'teal',
                   icon: 'mdi-gamepad-variant-outline',
                   headline: this.$t('sections.industries.cols.2.headline'),
                   description: this.$t('sections.industries.cols.2.description')
               }
            ];
        },
        timeline(){

            return [
                {date: '10-17-2023', title: this.$t('timeline.0.title'), content: this.$t('timeline.0.content')},
                {date: this.$t('timeline.1.date'), title: this.$t('timeline.1.title'), content: this.$t('timeline.1.content')}
            ];
        },
        ...GlobalComputed
    },
    methods: {
        scrollToSection(n){
            let i = n-1,
                element = document.querySelectorAll('.page-sections section')[i];
            if (element){
                this.scrollToElement(element);
            }
        },
        scrollObserver(){
            window.addEventListener('scroll', ()=>{
                this.currentScrollTop = document.documentElement.scrollTop;
            })
        },
        handleScrollChange(scrollTop){
            const sections = document.querySelectorAll('.page-sections section');
            sections.forEach(section => {
                let offsetTop = section.offsetTop - this.navbarHeight, // decrease navbarHeight
                    offsetBottom = offsetTop + section.offsetHeight;

                if (scrollTop >= offsetTop && scrollTop < offsetBottom){
                    let sectionName = section.getAttribute('data-section');
                    if(sectionName){
                        this.$store.commit('SET_ACTIVE_SECTION', sectionName)
                    }
                    // section is visible...
                    if (section.getAttribute('data-theme') === 'light'){

                        if (!this.lightNavbar){
                            this.$store.commit('SET_LIGHT_NAVBAR', true);
                        }
                    }else{
                        if (this.lightNavbar){
                            this.$store.commit('SET_LIGHT_NAVBAR', false);
                        }
                    }
                }
            })

        },

        ...GlobalMethods
    },
    watch: {
        currentScrollTop(top){
            this.handleScrollChange(top);
        }
    },

    mounted(){
        this.scrollObserver();
        AOS.init({container: document.documentElement, once: true, easing: 'ease'});
    }
};
</script>
<style lang="scss" scoped>
    section{

        .container{
            z-index: 1;
            display: flex;
            justify-content: center;
            align-items: start;
            flex-direction: column;

            &, *{
                z-index: 1;
            }
        }
        &.header-section{
            color: white;
        }
        h1{
            font-size: 4rem;
            font-weight: 300;

            @media(max-width: 960px){
                text-align: center;
                font-size: 1.7rem;
                line-height: 2.4rem;
                font-weight: 400;
            }
        }
        h2{
            font-size: 2.75rem;
            word-break: break-word!important;
            font-weight: 200;

            @media(max-width: 960px){
                text-align: center;
                font-size: 1.3rem;
                font-weight: 300;
            }
        }
        .actions{
            margin-top: 3rem;
            @media(max-width: 960px){
                margin: 2rem 0;
                width: 100%;
                text-align: center;
                justify-content: center;
            }
            .v-btn{
                @media(min-width: 960px){
                    min-width: 130px;
                    min-height: 45px;
                }
            }
        }
        .section-scroll-icon{
            z-index: 2;
            position: absolute;
            bottom: 8%;
            left: 50%;
            transform: translateX(-50%);
        }
    }
</style>
